<ng-container *transloco="let t">
<div class="d-flex flex-stack justify-content-center pt-5 pb-5 px-20">
  <div class="mr-2">
    @if (backVisible) {
      <button type="button" id="wizard-button-back" class="btn btn-lg btn-light-primary me-3"
        [disabled]="!backEnabled || spinnerVisible" (click)="onBackClicked()">
        <span class="svg-icon svg-icon-4 me-1">
          <duotone-navigation-left-svg-icon></duotone-navigation-left-svg-icon>
        </span>
        {{ t('common.back') }}
      </button>
    }
  </div>
  @if (nextVisible) {
    <div>
      <button type="button" id="wizard-button-next" class="btn btn-lg btn-primary"
        [disabled]="!nextEnabled || spinnerVisible" (click)="onNextClicked()">{{nextButtonText}}
        @if (!spinnerVisible) {
          <span class="svg-icon svg-icon-4 ms-1 me-0">
            <duotone-navigation-right-svg-icon></duotone-navigation-right-svg-icon>
          </span>
        }
        @if (spinnerVisible) {
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        }
      </button>
    </div>
  }
  @if (customButtons.length > 0) {
    <div>
      @for (button of customButtons; track $index; let index = $index) {
        <button class="btn btn-lg btn-primary ms-2" id="wizard-button-custom-{{index}}" type="button"
          [disabled]="!nextEnabled || spinnerVisible"
          (click)="button.onClick()">{{button.label}}
          @if (spinnerVisible) {
            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
          }
        </button>
      }
    </div>
  }
</div>
</ng-container>
